import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/**
 * Sign out and send the user to login so they can refresh credentials.
 * Used when the selected organization cannot be loaded (stale token, 403, etc.).
 */
export default function ForceReauth() {
    const { logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                await logout();
            } catch (err) {
                console.error(err);
            } finally {
                if (!cancelled) {
                    navigate('/login', { replace: true });
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [logout, navigate]);

    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
            <CircularProgress />
        </Box>
    );
}
